import React from 'react';

export default function IndicadoresPage() {
  return (
    <div>
      Qualidade - Indicadores (placeholder).
    </div>
  );
}

